<eff-switch size="sm" class="ml-xl" [formControl]="activeControl">
	<span class="text-body-sm text-on-surface">AI Assistant</span>
</eff-switch>
